// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_obj from "../../../../node_modules/rescript/lib/es6/caml_obj.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as PDPForm$Showside from "./PDPForm.bs.js";
import * as Product$Showside from "../types/Product.bs.js";
import * as CustomScript$Showside from "../utils/CustomScript.bs.js";
import * as ViewportContext$Showside from "../context/ViewportContext.bs.js";
import * as EntrypointContext$Showside from "../context/EntrypointContext.bs.js";
import * as ProductRulesConfig$Showside from "../types/ProductRulesConfig.bs.js";
import * as ProductCardCTAButton$Showside from "./ProductCardCTAButton.bs.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
function getActionLabel(action) {
  switch (action.TAG | 0) {
    case /* AddToCart */0:
      return action._0.label;
    case /* OpenLink */1:
      return action._0;
    case /* Custom */2:
      return action._0.label;
    case /* CustomAction */3:
      return action._0.label;
  }
}
function actionFromLegacy(action) {
  switch (action.TAG | 0) {
    case /* AddToCart */0:
      var match = action._0;
      return {
        TAG: /* AddToCart */0,
        _0: {
          textColor: match.textColor,
          bgColor: match.bgColor,
          label: match.label,
          overrideLabel: undefined,
          confirmationMessage: match.confirmationMessage
        }
      };
    case /* OpenLink */1:
      return {
        TAG: /* OpenLink */1,
        _0: action._0
      };
    case /* CustomAction */2:
      var match$1 = action._0;
      return {
        TAG: /* CustomAction */3,
        _0: {
          id: match$1.id,
          textColor: match$1.textColor,
          bgColor: match$1.bgColor,
          label: match$1.label,
          confirmationMessage: match$1.confirmationMessage,
          onClickFn: match$1.onClickFn,
          renderFn: match$1.renderFn
        }
      };
  }
}
function fromSettingsPDPCTAConfig(param) {
  return {
    primary: actionFromLegacy(param.primary),
    secondary: Belt_Option.map(param.secondary, actionFromLegacy),
    tertiary: Belt_Option.map(param.tertiary, actionFromLegacy)
  };
}
var context = React.createContext(undefined);
var provider = context.Provider;
function CTABar$OverrideContextProvider(Props) {
  var value = Props.value;
  var children = Props.children;
  return React.createElement(provider, {
    value: value,
    children: children
  });
}
CTABar$OverrideContextProvider.displayName = "CTABar.OverrideContextProvider";
function useWithDefault($$default) {
  var $$default$1 = fromSettingsPDPCTAConfig($$default);
  return Belt_Option.mapWithDefault(React.useContext(context), $$default$1, function (values) {
    var run = values.onClickPrimaryButton;
    var run$1 = values.onClickSecondaryButton;
    return {
      primary: run !== undefined ? {
        TAG: /* Custom */2,
        _0: {
          label: Belt_Option.getWithDefault(values.primaryButtonLabel, ""),
          disabledLabel: undefined,
          confirmationMessage: values.primaryButtonConfirmation,
          style: values.primaryButtonStyle,
          run: run
        }
      } : $$default$1.primary,
      secondary: run$1 !== undefined ? {
        TAG: /* Custom */2,
        _0: {
          label: Belt_Option.getWithDefault(values.secondaryButtonLabel, ""),
          disabledLabel: undefined,
          confirmationMessage: values.secondaryButtonConfirmation,
          style: undefined,
          run: run$1
        }
      } : $$default$1.secondary,
      tertiary: $$default$1.tertiary
    };
  });
}
var OverrideContextProvider = {
  getActionLabel: getActionLabel,
  actionFromLegacy: actionFromLegacy,
  fromSettingsPDPCTAConfig: fromSettingsPDPCTAConfig,
  context: context,
  provider: provider,
  make: CTABar$OverrideContextProvider,
  useWithDefault: useWithDefault
};
function buttonExists(cta, product, variant) {
  if (cta.TAG !== /* CustomAction */3) {
    return true;
  }
  var match = cta._0;
  var label = match.label;
  var html = Belt_Option.flatMap(match.renderFn, function (code) {
    return CustomScript$Showside.triggerCustomFunctionReturningString(code, product, variant, label, undefined, undefined);
  });
  if (html === "") {
    return false;
  } else {
    return true;
  }
}
function CTABar$CTAButtonWrapper(Props) {
  var product = Props.product;
  var variant = Props.variant;
  var isMobile = Props.isMobile;
  var cta = Props.cta;
  var disableWhenOutOfStock = Props.disableWhenOutOfStock;
  var isPrimaryOpt = Props.isPrimary;
  var size = Props.size;
  var onSubmit = Props.onSubmit;
  var tabIndex = Props.tabIndex;
  var isPrimary = isPrimaryOpt !== undefined ? isPrimaryOpt : false;
  var match = ViewportContext$Showside.use(undefined);
  var match$1 = EntrypointContext$Showside.use(undefined);
  var trackEvent = match$1.trackEvent;
  var isMobile$1 = Belt_Option.getWithDefault(isMobile, match.isMobile);
  var match$2 = ConfigurationProvider$Showside.use(undefined);
  var settings = match$2.config.settings;
  var ctaSize = isMobile$1 ? /* Md */2 : size !== undefined ? size : undefined;
  switch (cta.TAG | 0) {
    case /* AddToCart */0:
      var match$3 = cta._0;
      var overrideLabel = match$3.overrideLabel;
      var disabledLabel = Belt_Option.getWithDefault(overrideLabel, settings.outOfStockLabel);
      var label = Belt_Option.getWithDefault(overrideLabel, match$3.label);
      var style = isPrimary ? {
        backgroundColor: match$3.bgColor,
        color: match$3.textColor
      } : undefined;
      var tmp = {
        primary: isPrimary,
        labelDataTestId: "open-link-label",
        dataTestId: "pdp-button-add-to-cart"
      };
      if (ctaSize !== undefined) {
        tmp.size = Caml_option.valFromOption(ctaSize);
      }
      if (style !== undefined) {
        tmp.style = Caml_option.valFromOption(style);
      }
      if (tabIndex !== undefined) {
        tmp.tabIndex = Caml_option.valFromOption(tabIndex);
      }
      var tmp$1 = {
        children: React.createElement(ProductCardCTAButton$Showside.make, tmp),
        label: label,
        disabledLabel: disabledLabel,
        submitButtonType: /* AddToCart */0
      };
      if (disableWhenOutOfStock !== undefined) {
        tmp$1.disableWhenOutOfStock = disableWhenOutOfStock;
      }
      if (onSubmit !== undefined) {
        tmp$1.onSubmit = Caml_option.valFromOption(onSubmit);
      }
      return React.createElement(PDPForm$Showside.SubmitButton.make, tmp$1);
    case /* OpenLink */1:
      var tmp$2 = {
        disabled: false,
        primary: isPrimary,
        labelDataTestId: "open-link-label",
        dataTestId: "pdp-button-open-link"
      };
      if (ctaSize !== undefined) {
        tmp$2.size = Caml_option.valFromOption(ctaSize);
      }
      if (tabIndex !== undefined) {
        tmp$2.tabIndex = Caml_option.valFromOption(tabIndex);
      }
      var tmp$3 = {
        children: React.createElement(ProductCardCTAButton$Showside.make, tmp$2),
        label: cta._0,
        submitButtonType: /* OpenLink */1
      };
      if (onSubmit !== undefined) {
        tmp$3.onSubmit = Caml_option.valFromOption(onSubmit);
      }
      return React.createElement(PDPForm$Showside.SubmitButton.make, tmp$3);
    case /* Custom */2:
      var match$4 = cta._0;
      var style$1 = isPrimary ? match$4.style : undefined;
      var tmp$4 = {
        primary: isPrimary,
        labelDataTestId: "custom-label",
        dataTestId: "pdp-button-custom"
      };
      if (ctaSize !== undefined) {
        tmp$4.size = Caml_option.valFromOption(ctaSize);
      }
      if (style$1 !== undefined) {
        tmp$4.style = Caml_option.valFromOption(style$1);
      }
      if (tabIndex !== undefined) {
        tmp$4.tabIndex = Caml_option.valFromOption(tabIndex);
      }
      var tmp$5 = {
        children: React.createElement(ProductCardCTAButton$Showside.make, tmp$4),
        label: match$4.label,
        submitButtonType: /* Custom */{
          confirmation: match$4.confirmationMessage,
          run: match$4.run
        }
      };
      if (match$4.disabledLabel !== undefined) {
        tmp$5.disabledLabel = match$4.disabledLabel;
      }
      if (onSubmit !== undefined) {
        tmp$5.onSubmit = Caml_option.valFromOption(onSubmit);
      }
      return React.createElement(PDPForm$Showside.SubmitButton.make, tmp$5);
    case /* CustomAction */3:
      var match$5 = cta._0;
      var onClickFn = match$5.onClickFn;
      var confirmationMessage = match$5.confirmationMessage;
      var label$1 = match$5.label;
      var id = match$5.id;
      var disabledLabel$1 = settings.outOfStockLabel;
      var style$2 = {
        backgroundColor: match$5.bgColor,
        color: match$5.textColor
      };
      var html = Belt_Option.flatMap(match$5.renderFn, function (code) {
        return CustomScript$Showside.triggerCustomFunctionReturningString(code, product, variant, label$1, undefined, undefined);
      });
      var tmp$6;
      if (html !== undefined) {
        tmp$6 = React.createElement("div", {
          className: CSS$Showside.prefix("inline-block cursor-pointer select-none flex flex-grow"),
          dangerouslySetInnerHTML: {
            __html: html
          }
        });
      } else {
        var tmp$7 = {
          primary: isPrimary,
          labelDataTestId: "custom-action-label",
          dataTestId: "pdp-button-custom-action"
        };
        if (ctaSize !== undefined) {
          tmp$7.size = Caml_option.valFromOption(ctaSize);
        }
        if (style$2 !== undefined) {
          tmp$7.style = Caml_option.valFromOption(style$2);
        }
        if (tabIndex !== undefined) {
          tmp$7.tabIndex = Caml_option.valFromOption(tabIndex);
        }
        tmp$6 = React.createElement(ProductCardCTAButton$Showside.make, tmp$7);
      }
      var tmp$8 = confirmationMessage === "" ? undefined : confirmationMessage;
      var tmp$9 = {
        children: tmp$6,
        label: label$1,
        disabledLabel: disabledLabel$1,
        submitButtonType: /* Custom */{
          confirmation: tmp$8,
          run: function (product, variant, quantity) {
            Curry.app(trackEvent, [{
              NAME: "clicked action",
              VAL: id
            }, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined]);
            CustomScript$Showside.triggerCustomFunction(onClickFn, product, variant, quantity, "CTA button", undefined, undefined);
          }
        }
      };
      if (onSubmit !== undefined) {
        tmp$9.onSubmit = Caml_option.valFromOption(onSubmit);
      }
      return React.createElement(PDPForm$Showside.SubmitButton.make, tmp$9);
  }
}
CTABar$CTAButtonWrapper.displayName = "CTABar.CTAButtonWrapper";
var CTAButtonWrapper = {
  buttonExists: buttonExists,
  make: CTABar$CTAButtonWrapper
};
function CTABar(Props) {
  var product = Props.product;
  var variant = Props.variant;
  var isMobile = Props.isMobile;
  var size = Props.size;
  var primaryOpt = Props.primary;
  var secondaryOpt = Props.secondary;
  var tertiaryOpt = Props.tertiary;
  var extraButton = Props.extraButton;
  var tabIndex = Props.tabIndex;
  var primary = primaryOpt !== undefined ? primaryOpt : true;
  var secondary = secondaryOpt !== undefined ? secondaryOpt : true;
  var tertiary = tertiaryOpt !== undefined ? tertiaryOpt : true;
  var match = ConfigurationProvider$Showside.use(undefined);
  var match$1 = match.config;
  var transitiveAccount = match$1.transitiveAccount;
  var ctaConfig = useWithDefault(match$1.settings.pdpCTAConfig);
  var match$2 = ctaConfig.primary;
  var match$3 = ctaConfig.secondary;
  var match$4 = ctaConfig.tertiary;
  var hasAddToCartButton;
  var exit = 0;
  var exit$1 = 0;
  if (match$2 !== undefined && match$2.TAG === /* AddToCart */0) {
    hasAddToCartButton = true;
  } else {
    exit$1 = 2;
  }
  if (exit$1 === 2) {
    if (match$3 !== undefined && match$3.TAG === /* AddToCart */0) {
      hasAddToCartButton = true;
    } else {
      exit = 1;
    }
  }
  if (exit === 1) {
    hasAddToCartButton = match$4 !== undefined && match$4.TAG === /* AddToCart */0 ? true : false;
  }
  var match$5 = ctaConfig.primary;
  var match$6 = ctaConfig.secondary;
  var match$7 = ctaConfig.tertiary;
  var hasOpenLinkButton;
  var exit$2 = 0;
  var exit$3 = 0;
  if (match$5 !== undefined && match$5.TAG === /* OpenLink */1) {
    hasOpenLinkButton = true;
  } else {
    exit$3 = 2;
  }
  if (exit$3 === 2) {
    if (match$6 !== undefined && match$6.TAG === /* OpenLink */1) {
      hasOpenLinkButton = true;
    } else {
      exit$2 = 1;
    }
  }
  if (exit$2 === 1) {
    hasOpenLinkButton = match$7 !== undefined && match$7.TAG === /* OpenLink */1 ? true : false;
  }
  var hideAddToCartButton = hasAddToCartButton && Belt_Option.mapWithDefault(Belt_Option.flatMap(transitiveAccount, function (account) {
    return account.productRules.hideAddToCartButton;
  }), false, function (rule) {
    return ProductRulesConfig$Showside.matchesProduct(rule, product, variant);
  });
  var hideOpenLinkButton = hasOpenLinkButton && Belt_Option.mapWithDefault(Belt_Option.flatMap(transitiveAccount, function (account) {
    return account.productRules.hideOpenLinkButton;
  }), false, function (rule) {
    return ProductRulesConfig$Showside.matchesProduct(rule, product, variant);
  });
  var hideOpenLinkButton$1 = hideOpenLinkButton && !hideAddToCartButton;
  var overrideAddToCartLabel = Belt_Option.flatMap(Belt_Option.flatMap(transitiveAccount, function (account) {
    return account.productRules.customAddToCartText;
  }), function (data) {
    if (ProductRulesConfig$Showside.matchesProduct(data.rule, product, variant)) {
      return data;
    }
  });
  var disableWhenOutOfStock = Belt_Option.mapWithDefault(overrideAddToCartLabel, true, function (data) {
    return !data.overrideOutOfStock;
  });
  var overrideAddToCartLabel$1 = Belt_Option.map(overrideAddToCartLabel, function (data) {
    return data.text;
  });
  var moveUpPrimary = function (ctaConfig) {
    var match = ctaConfig.primary;
    var swap;
    if (match !== undefined) {
      switch (match.TAG | 0) {
        case /* AddToCart */0:
          swap = hideAddToCartButton;
          break;
        case /* OpenLink */1:
          swap = hideOpenLinkButton$1;
          break;
        case /* Custom */2:
        case /* CustomAction */3:
          swap = false;
          break;
      }
    } else {
      swap = false;
    }
    return {
      primary: swap ? ctaConfig.secondary : ctaConfig.primary,
      secondary: ctaConfig.secondary,
      tertiary: ctaConfig.tertiary
    };
  };
  var moveUpSecondary = function (ctaConfig) {
    var match = ctaConfig.secondary;
    var tmp;
    if (match !== undefined) {
      switch (match.TAG | 0) {
        case /* AddToCart */0:
          tmp = hideAddToCartButton;
          break;
        case /* OpenLink */1:
          tmp = hideOpenLinkButton$1;
          break;
        case /* Custom */2:
        case /* CustomAction */3:
          tmp = false;
          break;
      }
    } else {
      tmp = false;
    }
    var swap = tmp || Caml_obj.equal(Belt_Option.map(ctaConfig.primary, getActionLabel), Belt_Option.map(ctaConfig.secondary, getActionLabel));
    return {
      primary: ctaConfig.primary,
      secondary: swap ? ctaConfig.tertiary : ctaConfig.secondary,
      tertiary: ctaConfig.tertiary
    };
  };
  var moveUpTertiary = function (ctaConfig) {
    var match = ctaConfig.tertiary;
    var tmp;
    if (match !== undefined) {
      switch (match.TAG | 0) {
        case /* AddToCart */0:
          tmp = hideAddToCartButton;
          break;
        case /* OpenLink */1:
          tmp = hideOpenLinkButton$1;
          break;
        case /* Custom */2:
        case /* CustomAction */3:
          tmp = false;
          break;
      }
    } else {
      tmp = false;
    }
    var swap = tmp || Caml_obj.equal(Belt_Option.map(ctaConfig.secondary, getActionLabel), Belt_Option.map(ctaConfig.tertiary, getActionLabel));
    return {
      primary: ctaConfig.primary,
      secondary: ctaConfig.secondary,
      tertiary: swap ? undefined : ctaConfig.tertiary
    };
  };
  var setOverrideAddToCartLabelMaybe = function (ctaConfig, overrideLabel) {
    var match = ctaConfig.primary;
    var match$1 = ctaConfig.secondary;
    var match$2 = ctaConfig.tertiary;
    var exit = 0;
    if (match !== undefined) {
      if (match.TAG === /* AddToCart */0) {
        var addToCartProps = match._0;
        return {
          primary: {
            TAG: /* AddToCart */0,
            _0: {
              textColor: addToCartProps.textColor,
              bgColor: addToCartProps.bgColor,
              label: addToCartProps.label,
              overrideLabel: overrideLabel,
              confirmationMessage: addToCartProps.confirmationMessage
            }
          },
          secondary: ctaConfig.secondary,
          tertiary: ctaConfig.tertiary
        };
      }
      exit = 2;
    } else {
      exit = 2;
    }
    if (exit === 2 && match$1 !== undefined && match$1.TAG === /* AddToCart */0) {
      var addToCartProps$1 = match$1._0;
      return {
        primary: ctaConfig.primary,
        secondary: {
          TAG: /* AddToCart */0,
          _0: {
            textColor: addToCartProps$1.textColor,
            bgColor: addToCartProps$1.bgColor,
            label: addToCartProps$1.label,
            overrideLabel: overrideLabel,
            confirmationMessage: addToCartProps$1.confirmationMessage
          }
        },
        tertiary: ctaConfig.tertiary
      };
    }
    if (match$2 === undefined) {
      return ctaConfig;
    }
    if (match$2.TAG !== /* AddToCart */0) {
      return ctaConfig;
    }
    var addToCartProps$2 = match$2._0;
    return {
      primary: ctaConfig.primary,
      secondary: ctaConfig.secondary,
      tertiary: {
        TAG: /* AddToCart */0,
        _0: {
          textColor: addToCartProps$2.textColor,
          bgColor: addToCartProps$2.bgColor,
          label: addToCartProps$2.label,
          overrideLabel: overrideLabel,
          confirmationMessage: addToCartProps$2.confirmationMessage
        }
      }
    };
  };
  var ctaConfig$1 = setOverrideAddToCartLabelMaybe(moveUpTertiary(moveUpSecondary(moveUpPrimary(ctaConfig))), overrideAddToCartLabel$1);
  var match$8 = ctaConfig$1.primary;
  var primaryButton;
  if (primary && match$8 !== undefined) {
    var tmp = {
      product: product,
      variant: variant,
      cta: match$8,
      disableWhenOutOfStock: disableWhenOutOfStock,
      isPrimary: true,
      key: Product$Showside.getKey(variant, product)
    };
    if (isMobile !== undefined) {
      tmp.isMobile = isMobile;
    }
    if (size !== undefined) {
      tmp.size = Caml_option.valFromOption(size);
    }
    if (tabIndex !== undefined) {
      tmp.tabIndex = Caml_option.valFromOption(tabIndex);
    }
    primaryButton = Caml_option.some(React.createElement(React.Fragment, undefined, React.createElement(CTABar$CTAButtonWrapper, tmp), Belt_Option.getWithDefault(extraButton, null)));
  } else {
    primaryButton = undefined;
  }
  var match$9 = ctaConfig$1.secondary;
  var secondaryButton;
  if (secondary && match$9 !== undefined) {
    var tmp$1 = {
      product: product,
      variant: variant,
      cta: match$9,
      key: Product$Showside.getKey(variant, product)
    };
    if (isMobile !== undefined) {
      tmp$1.isMobile = isMobile;
    }
    if (size !== undefined) {
      tmp$1.size = Caml_option.valFromOption(size);
    }
    if (tabIndex !== undefined) {
      tmp$1.tabIndex = Caml_option.valFromOption(tabIndex);
    }
    secondaryButton = Caml_option.some(React.createElement(React.Fragment, undefined, React.createElement(CTABar$CTAButtonWrapper, tmp$1)));
  } else {
    secondaryButton = undefined;
  }
  var match$10 = ctaConfig$1.tertiary;
  var tertiaryButton;
  if (tertiary && match$10 !== undefined && buttonExists(match$10, product, variant)) {
    var tmp$2 = {
      product: product,
      variant: variant,
      cta: match$10,
      key: Product$Showside.getKey(variant, product)
    };
    if (isMobile !== undefined) {
      tmp$2.isMobile = isMobile;
    }
    if (size !== undefined) {
      tmp$2.size = Caml_option.valFromOption(size);
    }
    if (tabIndex !== undefined) {
      tmp$2.tabIndex = Caml_option.valFromOption(tabIndex);
    }
    tertiaryButton = Caml_option.some(React.createElement(CTABar$CTAButtonWrapper, tmp$2));
  } else {
    tertiaryButton = undefined;
  }
  var wrapButton = function (className, button) {
    return Belt_Option.mapWithDefault(button, null, function (btn) {
      return React.createElement("div", {
        className: Cn.make([className, CSS$Showside.prefix("flex space-x-4")])
      }, btn);
    });
  };
  return React.createElement("div", {
    className: CSS$Showside.prefix("grid gap-4 grid-cols-12")
  }, secondaryButton !== undefined ? tertiaryButton !== undefined ? React.createElement(React.Fragment, undefined, wrapButton(CSS$Showside.prefix("col-span-12"), primaryButton), wrapButton(CSS$Showside.prefix("col-span-6"), secondaryButton), wrapButton(CSS$Showside.prefix("col-span-6"), tertiaryButton)) : React.createElement(React.Fragment, undefined, wrapButton(Belt_Option.isSome(extraButton) ? CSS$Showside.prefix("col-span-5") : CSS$Showside.prefix("col-span-6"), secondaryButton), wrapButton(Belt_Option.isSome(extraButton) ? CSS$Showside.prefix("col-span-7") : CSS$Showside.prefix("col-span-6"), primaryButton)) : tertiaryButton !== undefined ? React.createElement(React.Fragment, undefined, wrapButton(Belt_Option.isSome(extraButton) ? CSS$Showside.prefix("col-span-5") : CSS$Showside.prefix("col-span-6"), tertiaryButton), wrapButton(Belt_Option.isSome(extraButton) ? CSS$Showside.prefix("col-span-7") : CSS$Showside.prefix("col-span-6"), primaryButton)) : wrapButton(CSS$Showside.prefix("col-span-12"), primaryButton));
}
CTABar.displayName = "CTABar";
var make = CTABar;
export { OverrideContextProvider, CTAButtonWrapper, make };
/* context Not a pure module */